import { render, staticRenderFns } from "./loginSso.pug?vue&type=template&id=12375383&lang=pug&"
import script from "./loginSso.js?vue&type=script&lang=js&"
export * from "./loginSso.js?vue&type=script&lang=js&"
import style0 from "./loginSso.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12375383')) {
      api.createRecord('12375383', component.options)
    } else {
      api.reload('12375383', component.options)
    }
    module.hot.accept("./loginSso.pug?vue&type=template&id=12375383&lang=pug&", function () {
      api.rerender('12375383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginSso/index.vue"
export default component.exports